import WidgetsMgr from 'widgets/widgetsMgr';
import 'widgets/widgetsList';

/*
Don't delete next comment, it's a placeholder for additional imports
See details in documentation/tools/WebpackConfiguration.md
 */
import 'int_shoppay_ext/widgetsList.ts';
import 'int_hubbox_ext/widgetsList.ts';
import 'int_klaviyo_ext/widgetsList.ts';
import 'int_afterpay_ext/widgetsList.ts';
import 'int_adyen_SFRA/adyenWidgetLists.ts';
import 'int_adyen_ext/widgetsList.ts';
import 'int_paypal/paypalWidgetLists.ts';
import 'int_paypal_ext/paypalWidgetLists.ts';
import 'int_cash_on_delivery/codWidgetsList.ts';
import 'int_custom_service_cloud/widgetsList.ts';
import 'int_custom_optimizely/widgetsList.ts';
import 'plugin_storelocator/widgetsList.ts';
import 'plugin_priceslider/widgetsList.ts';
import 'plugin_wishlists/wishlistWidgetsList.ts';
import 'plugin_wishlists_ext/wishlistWidgetsList.ts';
import 'int_gtm/widgetsList.ts';
import 'int_gtm/clientGTM.ts';
import 'plugin_serviceworker/sw-registration.ts';
import 'int_custom_tabby/widgetsList.ts';
import 'int_custom_kcp/widgetsList.ts';
import 'plugin_page_designer/pageDesignerWidgetsList.ts';
import 'plugin_page_designer_ext/pagedesignerWidgetList.ts';
import 'plugin_googlerecaptcha/widgetsList.js';
import 'core/widgetsList';
import { initPageEvents } from './pageEvents';

WidgetsMgr.run();

if (module.hot) {
    module.hot.accept(['widgets/widgetsList', 'core/widgetsList'], () => WidgetsMgr.restartWidgets());
}

// Initialize page event listeners
initPageEvents();
